import React, { useState } from "react";
import "./Faq.css";
import axios from "axios";
import { message } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const FaqNewYear = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    package: "",
    message: "",
  });

  // Handle input change
  const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ Phone validation: allow only digits & max 10 characters
  if (name === "phone") {
    if (value.length > 10) return; // Block if more than 10 digits
    if (!/^\d*$/.test(value)) return; // Block non-digit characters
  }

  setFormData({ ...formData, [name]: value });
};


  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("api/inquiry/add-inquiry", formData);
      if (response.data.success) {
        message.success(response.data.message);
        setFormData({ name: "", phone: "", package: "", message: "" });
      } else {
        message.error("Failed to submit inquiry.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("There was an error. Please try again.");
    }
  };
  return (
    <React.Fragment>
      <div className="faq-container Mon_font">
        <h2 className="faq">Frequently Asked Questions</h2>
        
        <div className="faq-content">
          {/* Left side - FAQ questions */}
          <div className="faq-questions">
            <div className="accordion" id="accordionFlushExample">
              {/* FAQ 1 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
What’s special about the NYE Thailand Trips?                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
 Our NYE Thailand Trip is an invite-only batch curated for exclusive travelers who want a more premium yet social
 experience. This limited-edition trip includes  yacht parties, island-hopping adventures, and beachfront
 celebrations across Phuket, Krabi, and Koh Samui.
  Only 5 seats left — once they’re gone, this batch closes permanently!                  </div>
                </div>
              </div>
              {/* FAQ 2 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
 What happens after the trip ends?
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
 The tribe never ends 
 — we stay connected through High Mountains Alumni Groups, special reunions, and future
 adventure invites.
 We’ll see you again — same vibe, new tribe members, and a new destination!                  </div>
                </div>
              </div>
              {/* FAQ 3 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
What are NYE Trips by High Mountains?
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingThree"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
Our NYE Trips are specially curated New Year group adventures designed for young travelers who want to celebrate
 the year’s end in iconic destinations like Thailand, Bali, Ladakh, Kashmir, and the Philippines. Expect a mix of
 exploration, parties, new friendships, and unforgettable vibes.                  </div>
                </div>
              </div>
  {/* FOUR  */}
          {/* <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFour">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFour"
                aria-expanded="false"
                aria-controls="flush-collapseFour"
              >
 Who can join these trips?
              </button>
            </h2>
            <div
              id="flush-collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFour"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
               Our NYE Trips are specially curated New Year group adventures designed for young travelers who want to celebrate
 the year’s end in iconic destinations like Thailand, Bali, Ladakh, Kashmir, and the Philippines. Expect a mix of
 exploration, parties, new friendships, and unforgettable vibes.
              </div>
            </div>
          </div> */}
          {/* FIVE  */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFive">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFive"
                aria-expanded="false"
                aria-controls="flush-collapseFive"
              >
 Who can join these trips?
              </button>
            </h2>
            <div
              id="flush-collapseFive"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFive"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
               Anyone aged 18–39 with a passion for travel, fun, and adventure! Most travelers join solo, so it’s perfect for solo
 travelers, small groups, or first-time explorers looking to meet like-minded people.
              </div>
            </div>
          </div>
          {/* SIX  */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingSix">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSix"
                aria-expanded="false"
                aria-controls="flush-collapseSix"
              >
 Are these trips only for singles?
              </button>
            </h2>
            <div
              id="flush-collapseSix"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingSix"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
               No — while the vibe is youthful and social, couples and friends are also welcome. Every trip is built to create a friendly,
 open community vibe, where everyone feels included.

              </div>
            </div>
          </div>
          {/* SEVEN  */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingSeven">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSeven"
                aria-expanded="false"
                aria-controls="flush-collapseSeven"
              >
Are these trips luxury or budget-friendly?
              </button>
            </h2>
            <div
              id="flush-collapseSeven"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingSeven"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
              They are budget-friendly with premium touches — comfortable stays, great experiences, and smooth logistics
 without the overpriced tourist fluff. Our goal is to give you maximum experience at a fair price.
              </div>
            </div>
          </div>
          {/* EIGHT  */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingEight">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseEight"
                aria-expanded="false"
                aria-controls="flush-collapseEight"
              >
 What’s included in the NYE Trip packages?
              </button>
            </h2>
            <div
              id="flush-collapseEight"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingEight"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
              Each package includes accommodation, airport transfers, daily breakfast, sightseeing, internal travel, activities, and
 local support staff. Some destinations also include yacht parties, snow treks, or cultural experiences. You’ll find
 detailed inclusions under each package page.
              </div>
            </div>
          </div>
          {/* NINE  */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingNine">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseNine"
                aria-expanded="false"
                aria-controls="flush-collapseNine"
              >
 Are flights included?
              </button>
            </h2>
            <div
              id="flush-collapseNine"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingNine"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
               Flights are not included in most NYE packages unless mentioned otherwise. This gives travelers flexibility to book from
 their city of choice or extend their trip. However, our team can help you with flight assistance and coordination.

              </div>
            </div>
          </div>   {/* TEN */}
             <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingTen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTen"
                aria-expanded="false"
                aria-controls="flush-collapseTen"
              >
What type of accommodation do you provide?
              </button>
            </h2>
            <div
              id="flush-collapseTen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingTen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
               We choose verified hotels, boutique stays, and cozy homestays that match the vibe of the destination — clean, safe,
 and comfortable. All properties are personally vetted by our on-ground teams.

              </div>
            </div>
          </div>    {/* ELEVEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingEleven">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseEleven"
                aria-expanded="false"
                aria-controls="flush-collapseEleven"
              >
 How big are the group sizes?
              </button>
            </h2>
            <div
              id="flush-collapseEleven"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingEleven"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
           Group sizes usually range from 15 to 30 travelers depending on the destination. This ensures the perfect balance of
 energy, interaction, and manageability for an amazing community experience.

              </div>
            </div>
          </div>   {/* TWELVE */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingTwelve">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwelve"
                aria-expanded="false"
                aria-controls="flush-collapseTwelve"
              >
 Can I join if I’m traveling solo?
              </button>
            </h2>
            <div
              id="flush-collapseTwelve"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingTwelve"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
            Absolutely! Most of our travelers are solo adventurers, so you’ll never feel alone. By the first evening, you’ll already be
 vibing with your new tribe.

              </div>
            </div>
          </div> {/* THIRTEEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingThirteen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThirteen"
                aria-expanded="false"
                aria-controls="flush-collapseThirteen"
              >
How do I book my spot?
              </button>
            </h2>
            <div
              id="flush-collapseThirteen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingThirteen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
       Simply fill out the booking form on the trip page or click on “Reserve Your Spot”. Our team will connect with you for
 confirmation and payment details. You can also Schedule a Call to discuss before booking.

              </div>
            </div>
          </div> {/* FOURTEEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFourteen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFourteen"
                aria-expanded="false"
                aria-controls="flush-collapseFourteen"
              >
 What is the booking amount and payment policy?              </button>
            </h2>
            <div
              id="flush-collapseFourteen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFourteen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
       To secure your spot, a partial advance payment is required (mentioned on each trip page). The remaining balance
 must be cleared 8 days before departure.
 Note: The initial booking amount is non-refundable.

              </div>
            </div>
          </div> {/* FIFTEEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFifteen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFifteen"
                aria-expanded="false"
                aria-controls="flush-collapseFifteen"
              >
 What if I need to cancel?
              </button>
            </h2>
            <div
              id="flush-collapseFifteen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFifteen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
         Our standard cancellation policy applies to all NYE trips:
 45+ days before departure: 10% cancellation fee
 30–45 days before: 25%
 15–30 days before: 50%
 0–15 days before: 100%
 (Weather or government restrictions may lead to activity changes but no refunds.)
              </div>
            </div>
          </div>  {/* SIXTEEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingSixteen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSixteen"
                aria-expanded="false"
                aria-controls="flush-collapseSixteen"
              >
Are NYE trips safe for solo female travelers?
              </button>
            </h2>
            <div
              id="flush-collapseSixteen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingSixteen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
        Yes 
✅
 . Safety is our top priority. All our trips are guided by trusted local partners and managed directly by the High
 Mountains team. Many of our past travelers were solo women who loved the experience.
              </div>
            </div>
          </div>{/* SEVENTEEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingSeventeen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSeventeen"
                aria-expanded="false"
                aria-controls="flush-collapseSeventeen"
              >
 What should I pack for these trips?              </button>
            </h2>
            <div
              id="flush-collapseSeventeen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingSeventeen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
        You’ll receive a destination-specific packing checklist once you book — whether it’s winter gear for Ladakh,
 beachwear for Koh Samui, or casual resort fits for Bali.
              </div>
            </div>
          </div>{/* EIGHTEEN */}  <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingEighteen">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseEighteen"
                aria-expanded="false"
                aria-controls="flush-collapseEighteen"
              >
What kind of parties or celebrations happen on NYE?              </button>
            </h2>
            <div
              id="flush-collapseEighteen"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingEighteen"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body">
         Expect exclusive New Year parties, private beach events, bonfire nights, and yacht celebrations, depending on the
 destination. Each trip ensures you ring in 2026 with unforgettable vibes and new friends.
              </div>
            </div>
          </div> </div>
          </div>

          {/* Right side - Got Any Questions? */}
       {/* <div className="faq-contact">
            <h3>Got Any Questions?</h3>
            <p>You can ask about anything you need information about</p>

            <div className="contact-form">
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
    <PhoneInput
  country={'in'} // Default India
  value={formData.phone || ""}  // ✅ Bind phone correctly
  onChange={(phone, data) => {
    setFormData({
      ...formData,
      phone: phone, // ✅ Store full phone number
      countryCode: `+${data.dialCode}` // Optional, if required
    });
  }}
  countryCodeEditable={false}
  inputProps={{
    name: 'phone',
    required: true,
  }}
  containerStyle={{ width: "100%" , marginBottom: "15px"}}
  inputStyle={{ width: "100%", height: "45px", fontSize: "16px" }}
/>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                                    required

                />

                <input
                  className="form-control"
                  placeholder="Enter the package/destination "
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  
                ></input>

                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default FaqNewYear;
